import script from "./require_payment.vue?vue&type=script&setup=true&lang=ts"
export * from "./require_payment.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__